import { Amplify } from 'aws-amplify';
import {
  signInWithRedirect,
  signOut,
  fetchAuthSession,
  fetchUserAttributes,
} from 'aws-amplify/auth';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, from, throwError } from 'rxjs';
import { AUTH_CONFIG } from '../token/auth.token';

export interface User {
  email: string;
  password: string;
  showPassword: boolean;
  code: string;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class CognitoService {
  private readonly config = inject(AUTH_CONFIG);
  constructor() {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: this.config.userPoolId,
          userPoolClientId: this.config.userPoolWebClientId,
          loginWith: {
            oauth: {
              domain: this.config.domain,
              scopes: this.config.scope,
              redirectSignIn: [this.config.redirectSignIn],
              redirectSignOut: [this.config.redirectSignOut],
              responseType: this.config.responseType,
            },
          },
        },
      },
    });
  }

  public signIn(): Observable<unknown> {
    return from(signInWithRedirect());
  }

  public signOut(): Observable<unknown> {
    return from(signOut()).pipe(
      catchError((err) => throwError(() => new Error(err))),
    );
  }

  public getCurrentUser(): Observable<any> {
    return from(fetchUserAttributes());
  }

  public fetchAuthSession(): Observable<any> {
    return from(fetchAuthSession());
  }
}
